import { memo } from 'react';

import DeleteIconSVG from '@/assets/delete-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDeleteIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DeleteIconSVG} {...props} />;

export const DeleteIcon = memo(IDeleteIcon) as typeof IDeleteIcon;
